import { ViewportRuler } from '@angular/cdk/overlay';
import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({ selector: '[scrollbarView]' })
export class ScrollbarViewDirective implements AfterViewInit {
  @Input() optionsLength: number;

  private cellsForSmall = 6;
  private cellsForLarge = 8;
  private height = this.viewport.getViewportSize().height;

  constructor(private el: ElementRef, private viewport: ViewportRuler) {}

  ngAfterViewInit(): void {
    this.scrollbarView();
  }

  private scrollbarView(): void {
    this.el.nativeElement.children[0].style.paddingRight = `${this.needsPadding() ? 20 : 0}px`;
  }

  private needsPadding(): boolean {
    const visibleItems = this.height > 800 && this.optionsLength > this.cellsForSmall ? this.cellsForLarge : this.cellsForSmall;
    return this.optionsLength > visibleItems ? true : false;
  }
}
